export default __webpack_public_path__ + "static/screeny-130-gpz-mb-2-0c61a79cd5cb63223657943bf297dc96.jpg";